import { render, staticRenderFns } from "./MyReturns.vue?vue&type=template&id=61a60904&"
import script from "./MyReturns.vue?vue&type=script&lang=js&"
export * from "./MyReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports